import React from "react";
import {
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import StyledDialog from "../../../../../Reuse/UI/Dialog/StyledDialog";

// Main Dialog component
const SimpleDialog = ({ open, closePopup, onSelect, list, status = "" }) => {
  return (
    <StyledDialog onClose={closePopup} open={open}>
      {/* Dialog Header */}
      <DialogTitle>Available {status}</DialogTitle>

      {/* Dialog Body */}
      <DialogContent sx={{ width: 500, padding: "0px !important" }} dividers>
        <Stack direction="column" gap={0}>
          {(Array.isArray(list) ? list : Object.values(list)).map(
            (el, index) => (
              <React.Fragment key={el.id || index}>
                {index > 0 && <Divider />}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={(e) => (el.isUsed ? null : onSelect(e, el))}
                  sx={(theme) => {
                    const { disabled } = theme.palette.action;
                    return {
                      cursor: el.isUsed ? "default" : "pointer",
                      // paddingX: 2,
                      paddingLeft: 2,
                      paddingY: 2,
                      backgroundColor: el.isUsed ? disabled : "inherit",
                      "&:hover": {
                        backgroundColor: el.isUsed ? disabled : "#f0f0f0",
                      },
                    };
                  }}
                >
                  <Typography>
                    <b>Device Id -</b> {el.device_id || "N/A"}
                  </Typography>
                </Stack>
              </React.Fragment>
            ),
          )}
        </Stack>
      </DialogContent>
    </StyledDialog>
  );
};

// Top-level wrapper that manages the dialog’s open state
const DialogUi = (props) => {
  return <SimpleDialog {...props} />;
};

export default React.memo(DialogUi);
